__webpack_require__.p = "/subway-kiosk/";